let currentSource: AudioBufferSourceNode | null = null;

export function playByteArray(byteArray: Uint8Array) {
  const context = new AudioContext();
  const arrayBuffer = new ArrayBuffer(byteArray.length);
  const bufferView = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteArray.length; i++) {
    bufferView[i] = byteArray[i] as unknown as number;
  }

  context.decodeAudioData(arrayBuffer, (buffer: AudioBuffer) => {
    play(context, buffer);
  });
}

function play(context: AudioContext, buf: AudioBuffer) {
  currentSource?.stop();

  // Create a source node from the buffer
  const source = context.createBufferSource();
  source.buffer = buf;
  // Connect to the final output node (the speakers)
  source.connect(context.destination);
  // Play immediately
  source.start(0);

  currentSource = source;
}

export function stopPlaying(): void {
  currentSource?.stop();
}
